<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
const XLSX = require("xlsx");

export default {
  template: `
    <div>
      <div class='is-flex' :class='isMovil ? "is-justify-center" : "" '>
        <button class="button is-link is-outlined" v-on:click='activeMenu'>Menú</button>
        <button class="button is-link" style="margin-left: 5px" v-on:click="downloadUsers()">
        <span v-tooltip="'Descargar los usuarios pendientes'" class="icon">
          <i class="material-icons">cloud_download</i>
        </span>
        </button>
        <button class="button is-link" style="margin-left: 5px" v-on:click="sendAllEmails()">
        <span v-tooltip="'Enviar correo a todos los pendientes'" class="icon">
          <i class="material-icons">email</i>
        </span>
        </button>
      </div>
      <nav id='menuFilter' v-if='active' class="panel">
        <div class="panel-heading">
          <div class='is-size-6 is-flex'>
            <!-- Title -->
          </div>
          <button class="delete" aria-label="delete" v-on:click='activeMenu'></button>
        </div>
        <div class='panel-body'>
          <p class="panel-tabs has-text-centered">
            <span class='has-text-weight-bold'>Encuestas</span>
          </p>
          <a class="panel-block file-label" :class='elements[0].active ? "is-active" : ""'>
            <input v-on:change='uploadData' ref='inputFileRelations' type='file' class='file-input' name='file' id='file' :accept="inputAccept" style='cursor: pointer; width: 100%; height: 100%'>
            {{ elements[0].name }}
          </a>
          <a class="panel-block" :class='elements[1].active ? "is-active" : ""' v-on:click='downloadTemplateData'>
            {{ elements[1].name }}
          </a>
          <p class="panel-tabs has-text-centered">
            <span class='has-text-weight-bold'>Comentarios</span>
          </p>
          <a class="panel-block file-label" :class='elements[2].active ? "is-active" : ""'>
            <input v-on:change='uploadComments' ref='inputFileResponses' type='file' class='file-input' name='file' id='file' :accept="inputAccept" style='cursor: pointer; width: 100%; height: 100%'>
            {{ elements[2].name }}
          </a>
          <a class="panel-block" :class='elements[3].active ? "is-active" : ""' v-on:click='downloadComments'>
            {{ elements[3].name }}
          </a>
        </div>
      </nav>
    </div>
  `,
  data() {
    return {
      active: false,
      elements: [
        {
          name: "Cargar Datos",
          tooltip: "Cargar Excel de datos",
          active: false,
        },
        {
          name: "Descargar Plantilla",
          tooltip: "Descargar plantilla de datos",
          active: false,
        },
        {
          name: "Cargar Comentarios",
          tooltip: "Cargar Excel de comentarios",
          active: false,
        },
        {
          name: "Descargar Comentarios",
          tooltip: "Descargar Excel de todo los comentarios",
          active: false,
        },
      ],
      filesAccept: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ],
      inputAccept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
      form: {
        advanceUpload: 0,
      },
    };
  },
  props: {
    employees: Array,
    proceso: Object,
  },
  computed: {
    ...mapState(["isMovil"]),
  },
  methods: {
    activeMenu() {
      this.active = !this.active;
    },
    uploadData(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.form.advanceUpload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (percentage > 10) {
              _this.form.advanceUpload = percentage;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
            e.target.files = null;
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              _this.form.advanceUpload = 0;
              const data = {
                url: url,
                proceso: this.proceso._id,
              };
              const result = await apiServices.post(
                `/saveempleadoslote2`,
                data
              );
              if (result.data) {
                e.target.files = null;
                await this.calculateAll();
              }
            } catch (err) {
              console.log("ocurrio un error", err);
              e.target.files = null;
            }
          }
        );
      }
      this.activeMenu();
    },
    uploadComments(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.form.advanceUpload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (percentage > 10) {
              _this.form.advanceUpload = percentage;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
            e.target.files = null;
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              _this.form.advanceUpload = 0;
              const data = {
                url: url,
                proceso: this.proceso._id,
              };
              const result = await apiServices.post(
                `/saveurlcomentariosclima`,
                data
              );
              if (result.data) {
                e.target.files = null;
                await this.getEmployees();
              }
            } catch (err) {
              console.log("ocurrio un error", err);
              e.target.files = null;
            }
          }
        );
      }
      this.activeMenu();
    },
    async downloadTemplateData() {
      try {
        let result;
        result = await apiServices.post(
          `/downexempleempleados2`,
          { proceso: this.proceso._id },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        this.activeMenu();
      } catch (e) {
        console.log(e);
      }
    },
    async downloadComments() {
      try {
        let result;
        result = await apiServices.post(
          `/downcomentariosclima`,
          { proceso: this.proceso._id },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Comentarios.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        this.activeMenu();
      } catch (err) {
        console.log(err);
      }
    },
    async getEmployees() {
      await this.$emit("getEmployees");
    },
    async calculateAll() {
      this.$emit("calculateAll");
    },
    async downloadUsers() {
      try {
        let data = await this.formatData(this.employees);

        if (data.data.length > 0) {
          //  Recorremos las diferentes datas creando un Excel para cada uno
          for (let i = 0; i < data.data.length; i++) {
            //  Asignamos la informacion necesaria a nuevas variables
            let dataExc = data.data[i];
            let name = data.names[i];
            //  Se agrega la data al libro de excel
            const ws = XLSX.utils.json_to_sheet(dataExc);

            //  Se configura el tamaño de cada columna
            const widths = this.$emit("widthCols", dataExc);
            ws["!cols"] = widths;

            //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Usuarios pendientes");
            const nombreArchivo = name + ".xlsx";
            XLSX.writeFile(wb, nombreArchivo);
          }
        } else {
          await this.$store.dispatch("notify", {
            message: `No hay datos para descargar`,
            type: "is-link",
          });
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    async formatData(d) {
      let data = [];
      try {
        d.map((x) => {
          if (x.status !== "Calculado") {
            const user = {
              Correo: x.email,
              Cédula: x.cedula,
              Nombre: x.nombre,
              Estado: x.status,
            };

            data.push(user);
          }
        });
        return {
          data: [data],
          names: ["Usuarios sin Calcular"],
        };
      } catch (err) {
        console.log(err);
        await this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel.`,
          type: "is-danger",
        });
      }
    },
    async sendAllEmails() {
      const config = {
        title: "¿Estás seguro?",
        text: "Enviaras un correo a todos los empleados de las relaciones.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#de5b5b",
        confirmButtonText: "Sí, enviar",
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          let result;
          try {
            result = await apiServices.post(`/enviarcorreolote1`, {
              proceso: this.proceso._id,
            });
            if (result.isDenied) {
              await this.$swal({
                text: "Error al enviar todos los correos.",
                icon: "error",
                showConfirmButton: false,
                timer: 1700,
              });
            } else if (result.data) {
              await this.$swal({
                text: "Correo enviados correctamente.",
                icon: "success",
                showConfirmButton: false,
                timer: 1700,
              });
              await this.getEmployees();
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
};
</script>
<style>
.panel-heading {
  display: flex;
  justify-content: space-between;
}

#menuFilter {
  margin-top: 15px !important;
  background: white;
  position: absolute;
  z-index: 250;
  max-height: 360px !important;
}

#menuFilter .panel-body {
  max-height: 300px !important;
  overflow: auto;
}

#menuFilter .panel-block {
  background-color: white;
}

#menuFilter .panel-block:hover {
  background-color: #f5f5f5 !important;
}

#menuFilter .is-active {
  border-left: solid 3px #41aae7;
  color: #363636;
  background: aliceblue;
}

.panel-block .panel-icon .material-icons {
  line-height: unset !important;
}

.buttons {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/menuTableSurvey.vue